<template lang="pug">
.ride-month-template-union(:class="isLotteryNew?'lotteryNew':''")
  .ride-top
    .ride-title {{title}}
    // - 待启用 | 有生效中
    .ride-go-mycard(v-if="(rideStatue === RideCardStatusMap.UN_USE)" @click="goMycard")
      ColumnCarousel.container(
        :dataList="getRollText()"
        :autoplay="5000"
      )
        .item(slot-scope="slotProps" v-html="slotProps.itemData")
  .ride-card(:class="[type,status]")
    .card-info
      .card-info-line-one
        span {{getTitle()}}
      .ride-num
        .have-day(v-if="rideDays>0&&cardsStatus===2 && status !== RideCardStatusEnum.WAIT_FOR_RECEIVE")
          .small-sign 剩
          .big-num {{totalCardTimes?rideTimes:rideDays}}
          .small-sign {{totalCardTimes?'次':'天'}}
        .no-day(
          v-else-if="rideDays===0&&cardsStatus===2 && status !== RideCardStatusEnum.WAIT_FOR_RECEIVE"
        ) 今日到期
        .can-use(v-else-if="showRideCardTouting&&isOpen && status !== RideCardStatusEnum.WAIT_FOR_RECEIVE"
          @click="goUse"
          :class="'can-use-v2'") {{env.isEasyBikeApp?'领取':'去APP使用'}}
    .card-logo
    .empty
    .button-wait-open(v-if="status === RideCardStatusEnum.WAIT_FOR_RECEIVE" @click="goMycard")
      .suo_icon
      .text 待启用
    slot
</template>
<script>
import { env } from '@hb/hbridge';
import config from '@/const/config';
import eventBus from '@/const/eventBus.js';
import { RideCardStatusEnum } from '@/const/vip';
import ColumnCarousel from '@/components/Carousel/ColumnCarousel.vue';
import { RideCardStatusMap } from '@/pages/vip/consts';

const initTemplate = (type) => ({
  ride: {
    title: '单车不限次卡',
    heading: '单车',
  },
  ebike: {
    title: '30天6次卡',
    heading: '助力车',
  },
})[type];

const defaultType = 'ride';

export default {
  name: 'RideMonthUnionTemplate',
  components: {
    ColumnCarousel,
  },
  props: {
    type: {
      type: String,
      default: defaultType,
    },
    status: {
      type: String,
      default: '',
    },
    totalCardDays: {
      type: Number,
      default: 0,
    },
    totalCardTimes: {
      type: Number,
      default: 0,
    },
    rideStatue: {
      type: Number,
      default: 0,
    },
    cardsStatus: {
      type: Number,
      default: 0,
    },
    rideTimes: {
      type: Number,
      default: 0,
    },
    rideDays: {
      type: Number,
      default: 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    showRideCardTouting: {
      type: Boolean,
      default: false,
    },
    cardInfo: {
      type: Object,
      default: () => ({}),
    },
    rideCardInfoValue: {
      type: Boolean,
      default: false,
    },
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '单车月卡',
    },
  },
  data() {
    return {
      template: initTemplate(defaultType),
      RideCardStatusEnum,
      env,
      RideCardStatusMap,
    };
  },
  watch: {
    type: {
      handler(val) {
        if (Object.keys(this.cardInfo).length <= 0) {
          this.initTemplate(val);
        }
      },
      immediate: true,
    },
  },
  created() {
    eventBus.$on('chooseAggCard', (card) => {
      if (Object.keys(card).length > 0) {
        this.template.title = `${card.propEffectiveDays}天${card.propTimes}次卡`;
      }
    });
  },
  methods: {
    goMycard() {
      if (env.isEasyBikeApp) {
        window.location.href = 'hellobike://hellobike.com/moped/business/htr_my_card_page';
      } else {
        window.location.href = `https://m.hellobike.com/AppHelloBikeMainH5/${config.env !== 'pro' ? `${config.env}/` : ''}latest/index.html#/my-cards?adsource=`;
      }
    },
    getTitle() {
      if (this.isOpen && this.rideCardInfoValue) {
        return `${this.totalCardDays || 30}天${this.totalCardTimes ? this.totalCardTimes : '不限'}次卡`;
      }
      return this.template.title;
    },
    initTemplate(type) {
      this.template = initTemplate(type);
    },
    goUse() {
      this.$emit('goUse');
    },
    getRollText() {
      return ['有生效中', '的骑行卡'];
    },
  },

};
</script>
<style lang="less" scoped>
.ride-month-template-union {
  position: relative;
  height: 0.72rem;

  .ride-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .ride-title {
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
  }

  .ride-go-mycard {
    width: 0.6rem;
    color: rgba(125, 59, 42, 1);
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    background:url(https://m.hellobike.com/resource/gallery/59/_WnSPLJi_Group%201707483253.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .container{
      width: 100%;
      height: 0.22rem;
    }
    .item{
      width: 100%;
      height: 0.22rem;
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
      color:rgba(29, 65, 139, 1);
    }

    .icon {
      width: 0.12rem;
      height: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/MJGujh4N2B.png);
      background-repeat: no-repeat;
      background-size: 100%;
      margin-top: 0.01rem;
    }

    img {
      margin-top: 0.03rem;
      width: 0.12rem;
      height: 0.12rem;
    }
  }

  .ride-card {
    margin-top: 0.1rem;
    border-radius: 0.1rem;
    height: 0.72rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(to right, rgba(70, 181, 255, 1), rgba(21, 153, 253, 1), rgba(32, 155, 255, 1), rgba(32, 184, 255, 1));
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    .card-info {
      margin: 0.12rem 0 0.12rem 0.1rem;
      flex-grow: 1;
    }

    .empty {
      width: 0.1rem;
      height: 100%;
    }

    &.wait-for-receive {
      color: #fff;
      margin-top: 0.08rem;
    }

    .card-logo {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 0.53rem;
      height: 100%;
      background: url('https://m.hellobike.com/resource/gallery/59/B6xD-oIW_Mask%20group.png') right bottom no-repeat;
      background-size: 100% 100%;
    }

    &.receivable.ebike {
      color: white;
    }

    &.receivable.ride {
      color: white;
    }

    &.ride {
      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/59/B6xD-oIW_Mask%20group.png') right bottom no-repeat;
        background-size: 100% 100%;
      }
    }

    &.ebike {
      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/59/z7hOAMTq_Mask%20group.png') right bottom no-repeat;
        background-size: 100% 100%;
      }
    }

    .card-status-info {
      background: #b5c0cb;
      font-size: 0.12rem;
      color: white;
      align-self: flex-start;
      border-top-right-radius: 0.1rem;
      border-bottom-left-radius: 0.1rem;
      padding: 0 0.08rem;
      display: flex;
      white-space: nowrap;
      align-items: center;
    }

    .card-info-line-one {
      font-size: 0.15rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.02rem;
    }

    .dot {
      content: '';
      display: inline-block;
      width: 0.04rem;
      height: 0.04rem;
      background: white;
      border-radius: 50%;
      margin: 0 0.04rem;
      white-space: nowrap;
    }

    .ride-num {
      font-family: PingFangSC, PingFang SC, sans-serif;
      font-size: 0.14rem;
      font-weight: 400;
      color: #fff;
      line-height: 1;
      position: absolute;
      bottom: 0.12rem;


      .have-day {
        display: flex;
        align-items: flex-end;

        .big-num {
          font-family: "DIN Alternate", sans-serif;
          font-size: 0.2rem;
          font-weight: 500;
          line-height: 0.8;
        }

        .small-sign {
          line-height: 1;
        }
      }

      .can-use-v2 {
        min-width: 0.74rem;
        height: 0.32rem;
        background: #fff;
        color: #08f;
        font-size: 0.15rem;
        text-align: center;
        border-radius: 0.26rem;
        line-height: 0.32rem;
      }
    }

    .button-wait-open {
      min-width:0.6rem;
      background-color:#B9E0FE;
      display: flex;
      align-items: center;
      height:0.22rem;
      border-radius:0.08rem;
      padding:0.035rem 0.055rem 0.035rem 0.055rem;
      margin-left:0.12rem;
      position: absolute;
      bottom: 0.12rem;
      left:0;

      .suo_icon {
        width: 0.14rem;
        height: 0.14rem;
        background-image: url(https://m.hellobike.com/resource/gallery/350/nXEaENeU_suo.png);
        background-size: 100%;
        background-repeat: no-repeat;
      }

      .text {
        font-weight: 400;
        font-size: 0.12rem;
        line-height: 100%;
        color: rgba(0, 0, 0, 1);
      }
    }

  }
}
</style>
